<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-question-circle"></i> Support Center
      </Tab>
      <Tab tabid="tab-links">
        <i class="far fa-link"></i> App Links
      </Tab>
      <Tab tabid="tab-about">
        <i class="far fa-info-circle"></i> About
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">
        <ContentTitle>Support Center</ContentTitle>

        <LinkButton sizeClass="btn-lg" class="btn-primary" href="/support/ticket" icon="fa-phone" v-if="userHasCreatePermission(PermissionTypes.AdminPermissionTypes.helpdeskSupport)">Create Support Ticket</LinkButton>
      </TabPage>

      <TabPage tabid="tab-links">
        <ContentTitle>Windows Desktop App</ContentTitle>
        <ContentSubTitle>Handles automatic printing of sheets / labels in office &amp; production environments</ContentSubTitle>

        <strong>Windows Desktop App</strong>
        <div class="app-links">
          <a href="https://synergy-apps.s3-ap-southeast-2.amazonaws.com/glass-desktop-app/Synergy+Desktop+App-1.1.2-winx64.exe"><i class="far fa-external-link"></i> Synergy Desktop App</a>
        </div>

        <br /><br />
        <strong>Bullzip PDF Studio</strong><br />
        Required for PDF printing in the Windows Desktop App<br />
        <div class="app-links">
          <a href="https://www.bullzip.com/products/stu/index.php" target="_blank"><i class="far fa-external-link"></i> Bullzip PDF Studio</a><br />
          <small>Note: This is a 3rd party application, please review their terms and privacy policy before installing.</small>
        </div>

        <br /><br />
        <ContentTitle>Mobile App</ContentTitle>
        <ContentSubTitle>App for iOS and Android</ContentSubTitle>
        <div class="app-links">
          <h3 class="m-0">Apps</h3>
          <div class="app-badge">
            <a href='https://play.google.com/store/apps/details?id=au.com.synsoft.app&pcampaignid=web_share&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img class="android" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>
          </div>
          <div class="app-badge">
            <a href="https://apps.apple.com/au/app/synergy-software/id6452947709?itsct=apps_box_badge&amp;itscg=30200" style="overflow: hidden; border-radius: 13px; width: 250px; height: 83px;"><img class="ios" src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1691971200" alt="Download on the App Store" style="border-radius: 13px; width: 250px; height: 83px;"></a>
          </div>
          
        </div>

        <div class="app-links">
          <a href="https://apps.apple.com/au/app/synergy-software/id6452947709"><i class="far fa-external-link"></i> iPhone / iPad App</a><br />
          iPhone / iPad App
        </div>

      </TabPage>

      <TabPage tabid="tab-about">
        <ContentTitle>About</ContentTitle>
        
        <div class="app-links">
          <a href="/about/privacy" target="_blank">Privacy Policy</a>
        </div>
        <div class="app-links">
          <a href="/about/terms" target="_blank">Terms of Use</a>
        </div>

        <div class="app-links">
          <a href="/support/whatsnew">Whats New</a>
        </div>

      </TabPage>
    </template>
  </TabbedBox>
</template>

<style scoped>
.app-links {
  padding-bottom: 1em;
}
.app-links .app-badge {
  display: inline-block;
}
.app-links img.android {
  max-height: 100px;
}
.app-links img.ios {
  max-height: 70px;
}

</style>

<script>
export default {
  
}
</script>